import * as Colors from '../attrs/colors';

export const API_URL = window.config.REACT_APP_API_URL;
export const API_METRICS_URL = `${API_URL}/v1/metrics`;
export const API_PULSE_URL = `${API_URL}/v1/pulses`;
export const API_METRICS_V2_URL = `${API_URL}/v2/metrics`;
export const API_USER_URL = `${API_URL}/v1/user`;
export const API_REPORTS_URL = `${API_URL}/v1/reports`;

export const ROOT_DOMAIN = window.config.REACT_APP_ROOT_DOMAIN;
export const STUDIO_URL = window.config.REACT_APP_STUDIO_URL;
export const INSIGHTS_URL = `https://insights.glassnode.com`;
export const ACADEMY_URL = 'https://academy.glassnode.com';
export const DOCS_URL = 'https://docs.glassnode.com';
export const CHANGELOG_URL = `${DOCS_URL}/changelog`;
export const HIGHCHARTS_EXPORT_URL = window.config.REACT_APP_HIGHCHARTS_EXPORT_URL;
export const CUSTOMER_PORTAL_URL = `${API_USER_URL}/portal`;

export const PLAN_GUEST = 'guest';
export const PLAN_STANDARD = 'standard';
export const PLAN_ADVANCED = 'advanced';
export const PLAN_PROFESSIONAL = 'professional';

export const STATUS_INITIAL = 'initial';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';
export const STATUS_AUTHENTICATED = 'authenticated';
export const STATUS_UNAUTHENTICATED = 'unauthenticated';
export const STATUS_TOO_MANY_REQUESTS = 429;

export const TIER_1 = 1;
export const TIER_2 = 2;
export const TIER_3 = 3;

export const MODAL_LOGIN = 'loginForm';
export const MODAL_SIGNUP = 'signupForm';
export const MODAL_UPGRADE = 'upgrade';
export const MODAL_FORGOT_PASSWORD = 'forgotPasswordForm';
export const MODAL_PASSWORD_RESET = 'passwordResetForm';
export const MODAL_EMAIL_CONFIRMATION = 'emailConfirmationForm';
export const MODAL_NEWSLETTER_OPT_IN = 'newsletterOptIn';
export const MODAL_RESEND_EMAIL_CONFIRMATION = 'resendEmailConfirmation';
export const MODAL_DASHBOARD = 'dashboard';

export const FORMATTER_NUMBER = 'number';
export const FORMATTER_PERCENT = 'percent';
export const FORMATTER_PERCENT_PRECISE = 'percentPrecise';
export const FORMATTER_CURRENCY = 'currency';
export const FORMATTER_CURRENCY_USD = 'currencyUSD';
export const FORMATTER_UNIT_PER_SECOND = 'unitPerSecond';
export const FORMATTER_SECOND = 'second';
export const FORMATTER_TH_PER_SECOND = 'thPerSecond';
export const FORMATTER_TRILLION = 'trillion';

export const RESOLUTION_1M = '1month';
export const RESOLUTION_1W = '1w';
export const RESOLUTION_24H = '24h';
export const RESOLUTION_1H = '1h';
export const RESOLUTION_10MIN = '10m';

export const RESOLUTION_MAX_RANGE_10MIN = 365;

export const CHART_TYPE_TIMESERIES = 'timeSeries';
export const CHART_TYPE_COLUMN = 'column';

export const FORMAT_CSV = 'CSV';
export const FORMAT_JSON = 'JSON';

export const CURRENCY_PLACEHOLDER = '%CURRENCY%';
export const ASSET_PLACEHOLDER = '%ASSET%';

export const PAGE_TITLE = 'Glassnode Studio - On-Chain Market Intelligence';
export const PAGE_TITLE_SHORT = 'Glassnode Studio';

export const TIMESTAMP_FORMAT_UNIX = 'unix';
export const TIMESTAMP_FORMAT_HUMANIZED = 'humanized';

export const CURRENCY_NATIVE = 'native';
export const CURRENCY_USD = 'usd';

export const SCALE_LIN = 'lin';
export const SCALE_LOG = 'log';

export const ASSET_TOP = 'top';
export const ASSET_ERC20 = 'erc20';
export const ASSET_DEFI = 'defiToken';
export const ASSET_EXCHANGE = 'exchangeToken';
export const ASSET_STABLECOIN = 'stablecoin';
export const ASSET_TOKENIZED = 'tokenizedAsset';

export const EXCHANGES_NAMES = {
  aggregated: 'All Exchanges',
};

export const MINERS_NAMES = {
  aggregated: 'All Miners',
};

export const CATEGORIES = {
  favorites: 'Favorites',
  addresses: 'Addresses',
  derivatives: 'Derivatives',
  distribution: 'Distribution',
  entities: 'Entities',
  exchanges: 'Exchanges',
  fees: 'Fees',
  indexes: 'Indexes',
  lifespan: 'Lifespan',
  longShortTermHolders: 'Long/Short Term',
  marketIndicators: 'Market Indicators',
  miners: 'Miners',
  networkStats: 'Network Stats',
  priceAndMarketCap: 'Price and Market Cap',
  profitLoss: 'Profit/Loss',
  ratios: 'Ratios',
  supply: 'Supply',
  transactions: 'Transactions',
  unspentSpentOutputs: 'Unspent/Spent Outputs',
  volume: 'Volume',
  internal: 'Internal',
};

export const HALVING_DAYS = [1354114800000, 1468080000000, 1589234400000, 1710939600000, 1832824800000, 1954710000000];

export const DEFAULT_ASSET = 'BTC';
export const DEFAULT_METRIC_CODE = 'addresses.ActiveCount';
export const DEFAULT_EXCHANGE = 'aggregated';
export const DEFAULT_MINER = 'aggregated';
export const DEFAULT_CURRENCY = CURRENCY_NATIVE;
export const DEFAULT_SCALE = SCALE_LIN;
export const DEFAULT_MOVING_MATH = 0;
export const DEFAULT_RESOLUTION = RESOLUTION_24H;
export const DEFAULT_LOG_TICK_INTERVAL = 0.2;
export const DEFAULT_COLOR = Colors.OCEAN;
export const DEFAULT_ASSETS_ORDER = ['BTC', 'ETH', 'LTC', 'BCH'];

export const MOVING_AVERAGE = 'movingAverage';
export const MOVING_MEDIAN = 'movingMedian';
